module.exports = __webpack_public_path__ + "img/skyline.1e1ee125.png";